import _ from 'lodash'

export default {
    shortName(full_name) {
        let parts_name = full_name.split(' ')

        return `${parts_name[1][0]}.${parts_name[2][0]}. ${parts_name[0]}`
    },
    setEducationalPrograms(list_educational_programms) {
        if (list_educational_programms.length > 5) {
            return 'по всем направлениям подготовки, '
        } else if (list_educational_programms.length === 1) {
            return `по направлению подготовки «${list_educational_programms[0].name}», `
        } else {
            let result_eps = 'по направлениям подготовки '

            list_educational_programms.forEach((ep, index) => {
                result_eps += ` «${ep.name}»,`
            })

            return result_eps
        }
    },
    descriptionHours(data_semesters) {
        let dict_type_work_hours = {}
        let result_content = ''

        data_semesters.forEach((item_semester) => {
            item_semester.hours.forEach((hour) => {
                if (!dict_type_work_hours[`${hour.load}`]) {
                    dict_type_work_hours[`${hour.load}`] = 0
                }
                dict_type_work_hours[`${hour.load}`] += hour.value
            })
        })

        let last_el = Object.keys(dict_type_work_hours)[Object.keys(dict_type_work_hours).length - 1]

        for (let key in dict_type_work_hours) {
            result_content += `${key.toLowerCase()} – ${dict_type_work_hours[key]} акад. час.${last_el === key ? '' : '; '}`
        }

        return result_content
    },
    dateEstimation(commission_department){
        let date_estimation = commission_department.date_estimation.split(' ')

        return `«${date_estimation[0]}» ${date_estimation[1]} «${date_estimation[2]}г.»`
    },
    signatureDepartment(commission_members){
        let head_dep = _.find(commission_members, (comm) => { return comm.management_type === "Department" })
        let department_name = head_dep.management_name

        return `${head_dep.full_name} (${department_name})`
    },
    createPDF(technical_map) {
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        };
        const docInfo = {
            info: {
                title: `Экспертное заключение кафедры`,
                author: 'АмГУ',
                subject: '',
                keywords: ''
            },

            pageSize: 'A4',
            pageOrientation: 'portrait',

            content: [
                {
                    text: 'Экспертное заключение кафедры об электронном учебном курсе\n\n',
                    style: 'title'
                },
                {
                    text: `Электронный учебный курс «${technical_map.course_full_name}», ` +
                        `предоставленный составителем – ${technical_map.spec_employee?.degree2 ? technical_map.spec_employee.degree2 + ', ' : '' } ` +
                        `${technical_map.spec_employee?.degree1 ? technical_map.spec_employee.degree1 : '' } ` +
                        `${technical_map.full_name}, по дисциплине «${technical_map.list_disciplines[0]}» ` +
                        `${this.setEducationalPrograms(technical_map.list_educational_programms)} ` +
                        'соответствует рабочей программе дисциплины, утвержденной ' +
                        'и содержащей исчерпывающую информацию о применяемых технологиях ' +
                        'ЭО и ДОТ.',
                    style: 'base_text'
                },
                {
                    text: 'ЭУК полностью обеспечивает учебный процесс по соответствующей дисциплине. ' +
                        'Содержание ЭУК имеет все необходимые и достаточные средства для проведения обучения в онлайн ' +
                        '(дистанционном) режиме в объеме указанном в схеме реализации. ',
                    style: 'base_text'
                },
                {
                    text: `Электронный учебный курс «${technical_map.course_full_name}» ` +
                        'рекомендуется к размещению в СДО Moodle и внедрению в' +
                        `образовательный процесс по дисциплине «${technical_map.list_disciplines[0]}» ` +
                        'в соответствии со схемой реализации ЭО и ДОТ ' +
                        'по данной дисциплине.',
                    style: 'base_text'
                },
                {
                    text: [
                        {text: 'Рекомендуется ввести в образовательный процесс ', bold: true},
                        {
                            text: `${this.setEducationalPrograms(technical_map.list_educational_programms)}контактные часы, реализуемые в форме ` +
                                `электронного обучения, по дисциплине «${technical_map.list_disciplines[0]}» ` +
                                'в соответствии с учебным планом в следующем объеме: ' +
                                `${this.descriptionHours(technical_map.data_training.data_semesters)} ` +
                                '(в соответствии со схемой реализации ЭО и ДОТ по данной дисциплине).'
                        }
                    ],
                    style: 'base_text'
                },
                {
                    text: `\nРезолюция: «допущено к использованию с ${this.dateEstimation(_.find(technical_map.commission_members, (comm) => { return comm.management_type === "Department" }))}`,
                    style: 'signature_text'
                },
                {
                    text: '\n',
                    style: 'base_text'
                },
                {
                    style: 'tableSupport',
                    table: {
                        widths: ['50%', '50%'],
                        body: [
                            [
                                {text: 'Заведующий кафедрой', alignment: 'left'},
                                {text: `${this.signatureDepartment(technical_map.commission_members)}`, alignment: 'right'}
                            ]
                        ]

                    },
                    layout: 'noBorders'
                }

            ],

            styles: {
                signature_text:{
                    fontSize: 14,
                    margin: [20, 0, 0, 0],
                    font: 'Times'
                },
                base_text: {
                    fontSize: 14,
                    margin: [20, 0, 0, 0],
                    alignment: 'justify',
                    leadingIndent: 35,
                    lineHeight: 1.2,
                    font: 'Times'
                },
                base_text_list: {
                    fontSize: 12,
                    margin: [40, 0, 0, 0],
                    alignment: 'justify',
                    font: 'Times'
                },
                inner_base_text_list: {
                    fontSize: 12,
                    margin: [50, 0, 0, 0],
                    alignment: 'justify',
                    font: 'Times'
                },
                title: {
                    fontSize: 16,
                    alignment: 'center',
                    bold: true,
                    font: 'Times'
                },
                subtitle: {
                    fontSize: 12,
                    margin: [20, 0, 0, 0],
                    alignment: 'center',
                    bold: true,
                    font: 'Times'
                },
                header: {
                    fontSize: 9,
                    alignment: 'center',
                    font: 'Times'
                },
                normal: {
                    fontSize: 9,
                    alignment: 'justify',
                    font: 'Times',
                    leadingIndent: 18
                },
                column: {
                    fontSize: 9,
                    alignment: 'left',
                    font: 'Times'
                },
                tableBase: {
                    fontSize: 12,
                    font: 'Times'
                },
                tableSupport: {
                    fontSize: 14,
                    margin: [20, 0, 0, 0],
                    font: 'Times'
                },
                bold_additionally: {
                    fontSize: 12,
                    bold: true,
                    font: 'Times'
                }
            }
        }
        pdfMake.createPdf(docInfo).download(`Экспертное заключение кафедры - ${technical_map.course_full_name}.pdf`);
    }
}